<mat-card class="mat-card profile-card">
  <mat-toolbar class="mat-primary">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="form-title">{{
        'SUPPORT-ENT.EDUID-FORMS.TITLE' | translate
      }}</span>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="ticket-form">
    <form fxLayout="column" fxFill [formGroup]="ticketForm">
      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <mat-form-field fxFlex appearance="outline">
          <mat-label>
            {{ 'SUPPORT-ENT.EDUID-FORMS.FIELDS.NAME' | translate }}
          </mat-label>
          <input matInput formControlName="name" required />
        </mat-form-field>
        <mat-form-field fxFlex="90" fxFlex appearance="outline">
          <mat-label>
            {{ 'SUPPORT-ENT.EDUID-FORMS.FIELDS.EMAIL' | translate }}
          </mat-label>
          <input matInput formControlName="email" required />
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <mat-form-field fxFlex="50" fxFlex appearance="outline">
          <mat-label>
            {{ 'SUPPORT-ENT.EDUID-FORMS.FIELDS.EDUIDEMAIL' | translate }}
          </mat-label>
          <input matInput formControlName="eduidemail" />
        </mat-form-field>
        <mat-form-field class="indicator-selector" appearance="outline">
          <mat-select placeholder="Indicatif" formControlName="defaultDial">
            <mat-option [value]="'+41'"> +41 </mat-option>
            <mat-option [value]="'+33'"> +33 </mat-option>
            <mat-option [value]="'+49'"> +49 </mat-option>
            <mat-option [value]="'+39'"> +39 </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>
            {{ 'SUPPORT-ENT.EDUID-FORMS.FIELDS.TEL' | translate }}
          </mat-label>
          <input
            matInput
            formControlName="phone"
            type="number"
            placeholder="791234567" />
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field fxFlex appearance="outline">
          <mat-label>
            {{ 'SUPPORT-ENT.EDUID-FORMS.FIELDS.SUBJECT' | translate }}
          </mat-label>
          <input matInput formControlName="title" required />
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field fxFlex appearance="outline">
          <mat-label>
            {{ 'SUPPORT-ENT.EDUID-FORMS.FIELDS.DESCRIPTION' | translate }}
          </mat-label>
          <textarea matInput formControlName="description" required></textarea>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start">
        <app-file-drop
          dropZoneLabel="Glisser un fichier ici"
          (fileDropEvent)="dropped($event)"
          dropZoneClassName="drop-zone"
          contentClassName="drop-content">
          <ng-template
            appFileDropContentTmp
            let-openFileSelector="openFileSelector">
            <div
              [innerHTML]="
                'SUPPORT-ENT.EDUID-FORMS.FIELDS.IMPORTFILE' | translate
              "></div>
            <button
              type="button"
              (click)="openFileSelector()"
              mat-raised-button
              color="accent">
              {{ 'SUPPORT-ENT.EDUID-FORMS.FIELDS.CHOOSEFILE' | translate }}
            </button>
          </ng-template>
        </app-file-drop>
      </div>
      @if (isFileUploaded) {
        <div>
          @for (file of attachmentsTicket; track file) {
            <div
              class="files-uploaded"
              fxLayout="row"
              fxLayoutAlign="start center">
              <mat-icon class="delete-file" (click)="deleteFile(file.filename)"
                >cancel</mat-icon
              >{{ file.filename }}
            </div>
          }
        </div>
      }
    </form>
  </div>

  @if (isErrorCreate) {
    <div class="general-container" fxLayout="row" fxFill="100">
      <div class="message-box errorForm ticket-created">
        <app-error-message [error]="error.error" />
      </div>
    </div>
  }

  @if (isTicketCreated) {
    <div class="column">
      <div class="general-container" fxLayout="row" fxFill="100">
        <div class="message-box successForm ticket-created">
          {{ 'SUPPORT-ENT.EDUID-FORMS.SUCCESS' | translate }}
        </div>
      </div>
      <div class="row field-container button-container">
        <div fxFlex="100" fxLayoutAlign="end" style="padding-right: 20px">
          <button
            mat-raised-button
            matStepperNext
            type="button"
            color="accent"
            (click)="closeForms()"
            class="btn-submit">
            {{ 'GENERAL.CONFIRMANDLEAVE' | translate }}
          </button>
        </div>
      </div>
    </div>
  } @else {
    <div class="row" class="field-container button-container">
      <div fxFlex="50" style="padding-left: 20px">
        <button
          mat-raised-button
          matStepperNext
          type="button"
          color="warn"
          (click)="closeForms()"
          style="padding-right: 10px">
          {{ 'GENERAL.CANCEL' | translate }}
        </button>
      </div>
      <div fxFlex="50" fxLayoutAlign="end" style="padding-right: 20px">
        <button
          mat-raised-button
          type="button"
          color="accent"
          (click)="createServiceNowTicket()"
          [disabled]="ticketForm.invalid || isBusy">
          {{ 'GENERAL.SAVE' | translate }}
        </button>
      </div>
    </div>
  }
</mat-card>
